import { cva } from "class-variance-authority";

const stylesBg = cva(
  "w-[336px] right-0 flex flex-col rounded-[16px] overflow-hidden shadow-[0_2px_20px_rgba(0,0,0,.12)] max-h-[calc(100vh-80px)]",
  {
    variants: {
      mode: {
        light: "bg-light-background",
        dark: "bg-dark-fill-secondary backdrop-blur-[15px]"
      }
    }
  }
);

export { stylesBg };
